const SET_IS_EBS_ENABLED = 'SET_IS_EBS_ENABLED';
const SET_IS_EBS_LOADED = 'SET_IS_EBS_LOADED';
export default {
  namespaced: true,
  state: {
    isEbsEnabled: false,
    isEbsLoaded: false
  },
  actions: {},
  mutations: {
    [SET_IS_EBS_ENABLED]: (state, data) => {
      state.isEbsEnabled = data;     
    },
    [SET_IS_EBS_LOADED]: (state, data) => {
      state.isEbsLoaded = data;
    }
  }
};
